"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundActionButtonStyles = void 0;
var tslib_1 = require("tslib");
var actionButtonStyles_1 = require("./actionButtonStyles");
var emotion_1 = require("emotion");
var roundActionButtonStyles = function () { return (0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n"], ["\n  ", "\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n"])), (0, actionButtonStyles_1.actionButtonStyles)()); };
exports.roundActionButtonStyles = roundActionButtonStyles;
var templateObject_1;
